// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo } from "react";
import { LuX } from "react-icons/lu";

function SignOut({ onCancel, onConfirm }) {
  return (
    <div className="fixed inset-0 z-[100] select-none flex items-center justify-center bg-black/50 p-4">
      <div className="font-geist relative w-full max-w-[448px] bg-general-background rounded-lg border border-general-border shadow-lg flex flex-col text-left overflow-hidden">
        <div className="flex items-center px-4 pt-4 pb-3 shrink-0">
          <span className="flex-1 text-general-foreground text-xl font-semibold leading-6">
            Logout
          </span>
        </div>
        <div className="px-4 pb-4">
          <p className="text-unofficial-ghost-foreground text-sm font-normal leading-5">
            Are you sure you want to logout?
          </p>
        </div>
        <div className="flex gap-2 px-4 pb-4 shrink-0">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 flex items-center justify-center min-h-9 px-4 py-2 rounded-lg border border-general-border bg-general-background text-general-foreground text-sm font-medium hover:bg-general-accent ani"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 flex items-center justify-center min-h-9 px-4 py-2 rounded-lg bg-general-primary text-general-primary-foreground text-sm font-medium hover:opacity-90 ani"
          >
            Logout
          </button>
        </div>
        <button
          type="button"
          onClick={onCancel}
          className="absolute top-4 right-4 opacity-70 hover:opacity-100 ani"
        >
          <LuX className="size-4 text-general-foreground" />
        </button>
      </div>
    </div>
  );
}

export default memo(SignOut);
